// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_id__wrapper__nZi8_"};